<template>
  <!-- WORKAROUND: Adjust width according to min-width of cockpit -->
  <footer class="app-footer" :class="{ 'app-footer-cockpit': isCockpit, 'app-footer-cx': isCx }">
    <div class="col-12 col-sm text-nowrap">
      <span v-if="appTarget === ''">MSM </span>Loop v{{ frontendVersion }} &copy; 
      <span>{{currentYear}}</span>
      <span><b>BOLD</b> Solution GmbH</span>
    </div>
    <b-nav class="col-12 col-sm-auto ml-auto">
      <b-nav-item to="/imprint">{{ $t("Webportal.Imprint") }}</b-nav-item>
      <b-nav-item to="/dataprotection">{{
        $t("Webportal.DataProtection")
      }}</b-nav-item>
    </b-nav>
    <div class="col-12 col-sm-auto ml-auto">Fon +49(0)-251-1321290</div>
    <div class="col-12 col-sm-auto ml-auto">
      <a v-bind:href="supportEmailHref">{{ supportEmail }}</a>
    </div>
  </footer>
</template>

<script>
import AppConfig from "@/mixins/AppConfig-APP_TARGET";

export default {
  name: "AppFooter",

  mixins: [AppConfig],

  computed: {
    isCockpit() {
      return this.$route.name === "Cockpit";
    },

    isCx() {
      return this.$route.name === "CX";
    },

    frontendVersion() {
      return FRONTEND_VERSION;
    },

    supportEmailHref() {
      return "mailto:" + this.getEmail();
    },

    supportEmail() {
      return this.getEmail();
    },

    appTarget() {
      return APP_TARGET;
    },
    currentYear() {
      return new Date().getFullYear();
    }
  },
};
</script>
<style>
.app-footer {
  z-index: 0;
}
</style>
<style scoped>
.app-footer-cx {
  position: fixed;
  width: 100%;
  bottom: 0%;
}
</style>
